import { formatDateTime } from '../lib/format'
import type { KeyChain } from '../lib/keyChains'
import { describeWarning, type OldSecretWarning } from '../lib/oldSecretWarning'

function getStatusBadge(status: string) {
  switch (status) {
    case 'active':
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
          Active
        </span>
      )
    case 'expired':
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
          Expired
        </span>
      )
    default:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
          {status}
        </span>
      )
  }
}

export default function KeyBadges({ chain, warnings }: { chain: KeyChain; warnings: OldSecretWarning[] }) {
  return (
    <>
      {warnings.length > 0 && (
        <span
          className={
            'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ' +
            'bg-amber-100 text-amber-900'
          }
          title={warnings.map((w) => describeWarning(w).title).join('; ')}
        >
          Old secret in use
        </span>
      )}
      {chain.lastRotatedAt && (
        <span
          className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
          title={`Rotated automatically on ${formatDateTime(chain.lastRotatedAt)}`}
        >
          Auto-rotated
        </span>
      )}
      {getStatusBadge(chain.current.status)}
    </>
  )
}
